var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4" },
    [
      _c(
        "div",
        { staticClass: "flex items-center gap-4" },
        [
          _c("JadeInputField", {
            attrs: {
              size: "medium",
              value: _vm.id,
              placeholder: _vm.$t("placeholder"),
              leadingItem: { type: "icon", content: "action-search" },
              label: "",
            },
            on: {
              "update:value": function ($event) {
                _vm.id = $event
              },
            },
          }),
          _c(
            "JadeButton",
            {
              staticClass: "w-20",
              attrs: {
                variant: "primary-solid",
                size: "medium",
                disabled: _vm.loading,
              },
              on: { click: _vm.searchClick },
            },
            [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
          ),
          _c("JadeIconButton", {
            attrs: {
              icon: "action-refresh",
              variant: "neutral-ghost",
              size: "medium",
            },
            on: { click: _vm.refreshClick },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex items-center justify-between" },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-4" },
            [
              _c("JadeDropdownSelection", {
                attrs: {
                  type: "multi",
                  searchable: "",
                  allowedPlacements: ["bottom-start"],
                  options: _vm.statusFilterOptions,
                },
                on: {
                  onApply: _vm.applyFilterStatus,
                  onClear: _vm.clearFiltersSearch,
                },
                scopedSlots: _vm._u([
                  {
                    key: "trigger",
                    fn: function () {
                      return [
                        _c(
                          "JadeActionButton",
                          {
                            attrs: {
                              disabled: _vm.loading,
                              active: !!_vm.status,
                              dropdownIndicator: "",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t(_vm.statusToString || "status")) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm.hasFilter
                ? _c(
                    "JadeButton",
                    {
                      attrs: { variant: "ghost", size: "small" },
                      on: { click: _vm.clearFiltersSearch },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("clear-filters")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "JadeActionButton",
            {
              staticClass: "max-w-40",
              attrs: { icon: "action-download", disabled: _vm.loading },
              on: { click: _vm.exportClick },
            },
            [
              _c("JadeText", { attrs: { weight: "semibold" } }, [
                _vm._v(" " + _vm._s(_vm.$t("download")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("JadeToastHub", { ref: "toast" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }